import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import config from 'config';
// import { Breadcrumbs } from '@mui/material';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const ContentDefault = Loadable(lazy(() => import('views/sample-page/display')));
const ReusableCmp = Loadable(lazy(() => import('views/sample-page/offRoadVehicle')));
const Powertrain = Loadable(lazy(() => import('views/sample-page/powertrain')));
const Commercial = Loadable(lazy(() => import('views/sample-page/commercial')));
const Electrical = Loadable(lazy(() => import('views/sample-page/electrical')));
const Carousel = Loadable(lazy(() => import('views/sample-page/about')));
const Tabs = Loadable(lazy(() => import('views/sample-page/industrail')));
const Filtersearch= Loadable(lazy(()=> import('views/sample-page/Iframe')));
const OffRoadVehicle = Loadable(lazy(() => import('views/sample-page')));
const Manufacture = Loadable(lazy(() => import('views/sample-page/manufacture')));
const Software = Loadable(lazy(() => import('views/sample-page/software')));
const Dashboard = Loadable(lazy(() => import('views/sample-page/contact')));
const DTS= Loadable(lazy(() => import('views/sample-page/dts')));
// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page/index.js')));
const Favourite = Loadable(lazy(() => import('views/sample-page/favourite.js')));

//offroad
const Telemetrics_offroad = Loadable(lazy(() => import('views/sample-page/offroad/telemetric.js')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: "/",
    element: <MainLayout />, 
    children: [
        // {
        //     path: '/',
        //     element: <DashboardDefault />
        // },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/table',
            element: <ContentDefault />
        },
        {
            path: '/reusable',
            element: <ReusableCmp />
        },
        {
            path: '/Powertrain',
            element: <Powertrain />
        },
        {
            path: '',
            element: <OffRoadVehicle />
        },
        {
            path: '/tabs',
            element: <Tabs />
        },
        {
            path: '/commercial',
            element: <Commercial />
        },
        {
            path: '/electrical',
            element: <Electrical />
        },
        {
            path: '/carousel',
            element: <Carousel />
        },
        {
            path: '/filtersearch',
            element: <Filtersearch/>
        },
        {
            path: '/telemetrics',
            element: <Telemetrics_offroad/>
        },
        {
            path: '/utils/util-typography',
            element: <UtilsTypography />
        },
        {
            path: '/utils/util-color',
            element: <UtilsColor />
        },
        {
            path: '/utils/util-shadow',
            element: <UtilsShadow />
        },
        {
            path: '/icons/tabler-icons',
            element: <UtilsTablerIcons />
        },
        {
            path: '/icons/material-icons',
            element: <UtilsMaterialIcons />
        },
        {
            path: '/sample-page',
            element: <SamplePage />
        },
        {
            path: '/favourite',
            element: <Favourite />
        },
        {
            path: '/manufacture',
            element: <Manufacture />
        },
        {
            path: '/software',
            element: <Software />
        },
        {
            path: '/dts',
            element: <DTS />
        },
    ]
};

export default MainRoutes;
